/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconListTree = createReactComponent("outline", "list-tree", "IconListTree", [["path", { "d": "M9 6h11", "key": "svg-0" }], ["path", { "d": "M12 12h8", "key": "svg-1" }], ["path", { "d": "M15 18h5", "key": "svg-2" }], ["path", { "d": "M5 6v.01", "key": "svg-3" }], ["path", { "d": "M8 12v.01", "key": "svg-4" }], ["path", { "d": "M11 18v.01", "key": "svg-5" }]]);

export { IconListTree as default };
//# sourceMappingURL=IconListTree.mjs.map
